import { InlineError, Input } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'

export const General = ({ productByCategoryDetail, onChangeForm, errorForm }) => {
    return (
        <TabToggle
            title={'General'}
            content={
                <div className={'flex flex-col space-y-3 w-1/2'}>
                    <div className={'font-semibold text-blue-90 required'}>Title</div>
                    <Input
                        className={'flex-1'}
                        name={'title'}
                        placeholder={'Masukkan title'}
                        value={productByCategoryDetail?.title}
                        onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                    />
                    <InlineError className='mt-2' message={errorForm?.title} />
                </div>
            }
        />
    )
}
